export /**
 *
 * Returns a human readable role
 * @param {string} role
 * @return {string}
 */
const getUserRole = (role) => {
  switch (role) {
    case "ADMIN":
      return "roles.admin";

    case "EMPLOYEE":
      return "roles.employee";

    case "CUSTOMER":
      return "Customer";

    default:
      return "roles.employee";
  }
};
